import React from "react";

export const SpiderIcon: React.FC = () => {
  return (
    <svg id="emoji" viewBox="0 0 72 72" xmlns="http://www.w3.org/2000/svg">
      <g id="color">
        <ellipse
          cx="36.22"
          cy="29.93"
          rx="8.644"
          ry="11.3"
          fill="#9b9b9a"
          stroke-width="1.33"
        />
        <circle
          cx="36.22"
          cy="45.89"
          r="4.654"
          fill="#9b9b9a"
          stroke-width="1.33"
        />
      </g>
      <g id="hair" />
      <g id="skin" />
      <g id="skin-shadow" />
      <g id="line">
        <path
          fill="none"
          stroke="#000"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
          d="m25.98 8.278s-14.61 29.22 9.296 33.2"
        />
        <path
          fill="none"
          stroke="#000"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
          d="m36.61 41.48c26.56-3.984 10.62-33.2 10.62-33.2"
        />
        <path
          fill="none"
          stroke="#000"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
          d="m61.4 21.34s-3.541 22.13-23.46 19.81"
        />
        <path
          fill="none"
          stroke="#000"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
          d="m10.6 21.45s5.201 21.36 23.57 20.03"
        />
        <path
          fill="none"
          stroke="#000"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
          d="m33.29 41.48s-12.62 9.668-5.976 18.59"
        />
        <path
          fill="none"
          stroke="#000"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
          d="m31.3 40.7s-18.59 7.415-13.28 22.02"
        />
        <path
          fill="none"
          stroke="#000"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
          d="m38.93 41.04s13.61 8.411 6.972 19.03"
        />
        <path
          fill="none"
          stroke="#000"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
          d="m42.03 40.92s18.7 7.857 12.62 22.8"
        />
        <ellipse
          cx="35.94"
          cy="30.19"
          rx="8.632"
          ry="11.29"
          fill="none"
          stroke="#000"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
        />
        <circle
          cx="35.94"
          cy="46.13"
          r="4.648"
          fill="none"
          stroke="#000"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
        />
      </g>
    </svg>
  );
};
